import L from 'leaflet';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet/dist/leaflet.css';
import { FeatureGroup, GeoJSON, MapContainer, Marker, Polygon, TileLayer, useMap } from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import { localeRu } from '../../leaflet-locale';
import React, { useEffect, useState } from 'react';
import { GeoJsonPoint } from '../../models/geoJsonPoint';
import markerIconPng from "leaflet/dist/images/marker-icon.png"

type Props = {
  geoJsonData: GeoJsonPoint | null,
  setGeoJsonData: (a: GeoJsonPoint | null) => void,
  polygonJson?: string | null
}

export const MapAddSingleMarker = ({ geoJsonData, setGeoJsonData, polygonJson }: Props) => {
  (L as any).drawLocal = localeRu;

  const [hasInitValue, setHasInitValue] = useState<boolean>(geoJsonData !== null);
  const [geoData, setGeoData] = useState<any>(null);
  const [selectedGeoData, setSelectedGeoData] = useState<any>(null);

  useEffect(() => {
    const fetchGeoData = async (
      file: string,
      setGeoData: React.Dispatch<React.SetStateAction<any>>,
      label: string
    ) => {
      try {
        const response = await fetch(`/${ file }`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data[0] && data[0].geojson) {

          setGeoData(data[0].geojson);
        } else {
          console.warn(
            `Данные geojson отсутствуют или неверный формат в ${ label }:`,
            data
          );
        }
      } catch (error) {
      }
    };

    fetchGeoData("polygons/search.json", setGeoData, "polygons/search.json");
  }, []);

  useEffect(() => {
    if (polygonJson) {
      const parsedData = JSON.parse(polygonJson);
      setSelectedGeoData(parsedData[0].geojson);
    }
  }, [polygonJson]);

  const onEachFeature = (feature: any, layer: any) => {
    layer.on({
      mouseover: (e: any) => {
        e.target.setStyle({
          weight: 4,
          fillOpacity: 0.7,
        });
      },
      mouseout: (e: any) => {
        e.target.setStyle({
          weight: 2,
          fillOpacity: 0.5,
        });
      },
    });
  };

  const ResizeMap = () => {
    const map = useMap();

    const getZoomByRegion = (regionName: string) => {
      switch (regionName) {
        case "Иссык-Кульская область, Киргизия": return 7;
        case "Ак-Суйский район, Иссык-Кульская область, Киргизия": return 8;
        case "Джети-Огузский район, Иссык-Кульская область, Киргизия": return 8;
        case "Иссык-Кульский район, Иссык-Кульская область, Киргизия": return 9;
        case "Тонский район, Иссык-Кульская область, Киргизия": return 8;
        case "Тюпский район, Иссык-Кульская область, Киргизия": return 9;

        case "Джалал-Абадская область, Киргизия": return 7;
        case "Ала-Букинский район, Джалал-Абадская область, Киргизия": return 9;
        case "Базар-Коргонский район, Джалал-Абадская область, 720800, Киргизия": return 9;
        case "Аксыйский район, Джалал-Абадская область, 715700, Киргизия": return 8;
        case "Ноокенский район, Джалал-Абадская область, Киргизия": return 9;
        case "Сузакский район, Джалал-Абадская область, Киргизия": return 9;
        case "Тогуз-Тороуский район, Джалал-Абадская область, 721500, Киргизия": return 9;
        case "Токтогульский район, Джалал-Абадская область, Киргизия": return 8;
        case "Чаткальский район, Джалал-Абадская область, Киргизия": return 8;

        case "Нарынская область, Киргизия": return 7;
        case "Ак-Талинский район, Нарынская область, Киргизия": return 8;
        case "Ат-Башинский район, Нарынская область, Киргизия": return 8;
        case "Жумгальский район, Нарынская область, 722700, Киргизия": return 9;
        case "Кочкорский район, Нарынская область, Киргизия": return 9;
        case "Нарынский район, Нарынская область, Киргизия": return 8;

        case "Баткенская область, Киргизия": return 8;
        case "Баткенский район, Баткенская область, 735932, Киргизия": return 9;
        case "Лейлекский район, Баткенская область, Киргизия": return 9;
        case "Кадамжайский район, Баткенская область, Киргизия": return 9;

        case "Ошская область, Киргизия": return 8;
        case "Алайский район, Ошская область, Киргизия": return 8;
        case "Араванский район, Ошская область, Киргизия": return 10;
        case "Кара-Сууский район, Ошская область, Киргизия": return 9;
        case "Ноокатский район, Ошская область, Киргизия": return 9;
        case "Кара-Кульджинский район, Ошская область, Киргизия": return 9;
        case "Узгенский район, Ошская область, Киргизия": return 9;
        case "Чон-Алайский район, Ошская область, 723700, Киргизия": return 9;

        case "Таласская область, Киргизия": return 9;
        case "Кара-Бууринский район, Таласская область, 723900, Киргизия": return 9;
        case "Бакай-Атинский район, Таласская область, Киргизия": return 9;
        case "Манасский район, Таласская область, Киргизия": return 10;
        case "Таласский район, Таласская область, Киргизия": return 9;

        case "Чуйская область, Киргизия": return 8;
        case "Аламудунский район, Чуйская область, Киргизия": return 9;
        case "Ысык-Атинский район, Чуйская область, Киргизия": return 9;
        case "Жайылский район, Чуйская область, Киргизия": return 8;
        case "Кеминский район, Чуйская область, Киргизия": return 9;
        case "Московский район, Чуйская область, Киргизия": return 9;
        case "Панфиловский район, Чуйская область, Киргизия": return 8;
        case "Сокулукский район, Чуйская область, Киргизия": return 9;
        case "Чуйский район, Чуйская область, Киргизия": return 9;

        case "город Бишкек, Киргизия": return 11;
        case "Ош, Киргизия": return 11;

      }

      return 6;
    }

    useEffect(() => {
      if (polygonJson) {
        const parsedData = JSON.parse(polygonJson);

        const { lat, lon, display_name } = parsedData[0];
        map.setView([lat as number, lon as number], getZoomByRegion(display_name)); // Центрирование карты
      }
    }, [geoJsonData, map]);
    map.invalidateSize();
    return null;
  };

  const getMarkerCords = (geometry: any) => {
    return {
      lat: geometry.coordinates[1] as number,
      lng: geometry.coordinates[0] as number
    }
  }

  const getLatLngs = (coords: number[][][]): L.LatLngExpression[][] => {
    return coords.map(ring =>
      ring.map(coord => [coord[1], coord[0]] as L.LatLngTuple)
    );
  };

  const _onCreated = (e: any) => {
    const layer = e.layer;
    const drawnGeoJson = layer.toGeoJSON();
    setGeoJsonData(drawnGeoJson);
  };

  const _onEdited = (e: any) => {
    const layers = e.layers;
    layers.eachLayer((layer: any) => {
      const editedGeoJson = layer.toGeoJSON();
      setGeoJsonData(editedGeoJson);
    });
  };

  const _onDeleted = (e: any) => {
    const layers = e.layers;
    layers.eachLayer(() => {
    });
    setGeoJsonData(null);
  };

  const _onDrawStart = (e: any) => {
    e.target.getContainer().querySelectorAll('.leaflet-interactive').forEach((element: any) => {
      (element as HTMLElement).classList.add('custom-cursor-active');
    });
  };

  const _onDrawStop = (e: any) => {
    e.target.getContainer().querySelectorAll('.leaflet-interactive').forEach((element: any) => {
      (element as HTMLElement).classList.remove('custom-cursor-active');
    });
  };

  const customIcon = new L.Icon({
    iconUrl: markerIconPng,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  return (
    <div>
      <MapContainer
        center={ [41.5089324, 74.724091] }
        zoom={ 6 }
        style={ { height: '400px', width: '100%', filter: 'url(#filter)' } }
        id='map'
      >
        <FeatureGroup>
          <EditControl
            key={ geoJsonData === null ? 'draw' : 'edit' }
            position='topright'
            draw={ {
              rectangle: false,
              polyline: false,
              circle: false,
              circlemarker: false,
              marker: geoJsonData == null && {
                icon: customIcon,
              },
              polygon: false,
            } }
            onCreated={ _onCreated }
            onEdited={ _onEdited }
            onDeleted={ _onDeleted }
            onDrawStart={ _onDrawStart }
            onDrawStop={ _onDrawStop }
          />
          {
            hasInitValue && geoJsonData && (geoJsonData.geometry?.type === 'Point' ?
                <Marker icon={ customIcon } position={ getMarkerCords(geoJsonData.geometry) }/> :
                <Polygon positions={ getLatLngs(geoJsonData.geometry?.coordinates as number[][][]) }/>
            )
          }
        </FeatureGroup>
        <ResizeMap/>
    <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
        { geoData &&
            <GeoJSON key={ JSON.stringify(geoData) } // Принудительное обновление
                     data={ geoData }
                     style={ {
                       color: 'rgba(95,108,96,0.45)',
                       weight: 2,
                       opacity: 1,
                       fillOpacity: 0.5,
                     } }
                     onEachFeature={ onEachFeature }/>
        }
        { selectedGeoData &&
            <GeoJSON key={ JSON.stringify(selectedGeoData) } // Принудительное обновление
                     data={ selectedGeoData }
                     style={ {
                       color: 'rgba(28,66,29,0.38)',
                       weight: 2,
                       opacity: 1,
                       fillOpacity: 0.5,
                     } }
                     onEachFeature={ onEachFeature }/>
        }
      </MapContainer>
    </div>
  );
}